var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgCommunityLine(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 28,
    height: 28,
    viewBox: "0 0 28 28",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M24.125 24.5H3.875C3.25368 24.5 2.75 23.9777 2.75 23.3333V14.5679C2.75 14.2308 2.89064 13.91 3.13567 13.6885L7.25 9.96841V4.66667C7.25 4.02234 7.75368 3.5 8.375 3.5H24.125C24.7463 3.5 25.25 4.02234 25.25 4.66667V23.3333C25.25 23.9777 24.7463 24.5 24.125 24.5ZM10.625 22.1667H14V15.0985L9.5 11.0297L5 15.0985V22.1667H8.375V17.5H10.625V22.1667ZM16.25 22.1667H23V5.83333H9.5V8.31517C9.76374 8.31517 10.0275 8.41094 10.2393 8.60247L15.8643 13.6885C16.1094 13.91 16.25 14.2308 16.25 14.5679V22.1667ZM18.5 12.8333H20.75V15.1667H18.5V12.8333ZM18.5 17.5H20.75V19.8333H18.5V17.5ZM18.5 8.16667H20.75V10.5H18.5V8.16667ZM14 8.16667H16.25V10.5H14V8.16667Z"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgCommunityLine);
export default __webpack_public_path__ + "static/media/community-line.9aae77ad17851d6b0c9f669700cf4d2c.svg";
export { ForwardRef as ReactComponent };